/* eslint-disable sort-keys-fix/sort-keys-fix */
const UserRoles = {
    ROLE_APPLICATION_MANAGERS: "ROLE_APPLICATION_MANAGERS",
    ROLE_ASSESSMENT_TEAM: "ROLE_ASSESSMENT_TEAM",
    ROLE_ASSESSORS: "ROLE_ASSESSORS",
    ROLE_BACKOFFICE: "ROLE_BACKOFFICE",
    ROLE_BEDRIJFSBUREAU: "ROLE_BEDRIJFSBUREAU",
    ROLE_CONSULTANTS: "ROLE_CONSULTANTS",
    ROLE_ASSOCIATES: "ROLE_ASSOCIATES",
    ROLE_CLIENT_CENTER: "ROLE_CLIENT_CENTER",
    ROLE_MANAGER: "ROLE_MANAGER",
    ROLE_PARTICIPANT: "ROLE_PARTICIPANT",
    ROLE_RESPONDENT: "ROLE_RESPONDENT",
    ROLE_REPORT_RECEIVER: "ROLE_REPORT_RECEIVER",
    ROLE_OFFICE_MANAGER: "ROLE_OFFICE_MANAGER",
    ROLE_OFFICE_MANAGER_NO_REPORT: "ROLE_OFFICE_MANAGER_NO_REPORT",
    ROLE_FINANCE: "ROLE_FINANCE",
    ROLE_CLIENT_ADMIN: "ROLE_CLIENT_ADMIN",
    ROLE_TEAM_ADMIN: "ROLE_TEAM_ADMIN",
    ROLE_TEAM_MANAGER: "ROLE_TEAM_MANAGER",
    ROLE_GROUP_REPORT_RECEIVER: "ROLE_GROUP_REPORT_RECEIVER",
    ROLE_TENDER_TEAM: "ROLE_TENDER_TEAM",
};

const ConsultingRoles = [UserRoles.ROLE_CONSULTANTS, UserRoles.ROLE_ASSOCIATES];

const LTPRoles = [
    UserRoles.ROLE_APPLICATION_MANAGERS,
    UserRoles.ROLE_ASSESSMENT_TEAM,
    UserRoles.ROLE_ASSESSORS,
    UserRoles.ROLE_BACKOFFICE,
    UserRoles.ROLE_BEDRIJFSBUREAU,
    UserRoles.ROLE_CONSULTANTS,
    UserRoles.ROLE_ASSOCIATES,
    UserRoles.ROLE_CLIENT_CENTER,
    UserRoles.ROLE_MANAGER,
    UserRoles.ROLE_FINANCE,
    UserRoles.ROLE_TENDER_TEAM,
];

const ParticipantRoles = [UserRoles.ROLE_PARTICIPANT];

const ClientRoles = [
    UserRoles.ROLE_REPORT_RECEIVER,
    UserRoles.ROLE_OFFICE_MANAGER,
    UserRoles.ROLE_CLIENT_ADMIN,
    UserRoles.ROLE_MANAGER,
    UserRoles.ROLE_OFFICE_MANAGER_NO_REPORT,
    UserRoles.ROLE_GROUP_REPORT_RECEIVER,
    UserRoles.ROLE_TEAM_ADMIN,
    UserRoles.ROLE_TEAM_MANAGER,
];

const DebugRoles = [
    UserRoles.ROLE_APPLICATION_MANAGERS,
    UserRoles.ROLE_CLIENT_CENTER,
    UserRoles.ROLE_BACKOFFICE,
    UserRoles.ROLE_ASSESSMENT_TEAM,
];

export { LTPRoles, ParticipantRoles, UserRoles, ClientRoles, DebugRoles, ConsultingRoles };
